import H3 from "../H3";

export const QIPBuildFeatures = ({ data }) => {
  return (
    <div className="max-w-restricted mx-auto bg-jay-blue text-white p-4 md:pt-9 md:pb-16 md:px-24 my-8 md:my-12">
      {data.title && <H3>{data.title}</H3>}

      {data.features &&
        (() => {
          const half = Math.ceil(data.features.length / 2);
          const col1 = data.features.slice(0, half);
          const col2 = data.features.slice(half);

          return (
            <div className="w-full">
              {/* Column 1 */}
              <ul className="w-full md:w-[calc(50%-1rem)] md:float-left list-none p-0 m-0">
                {col1.map((item, i) => (
                  <li
                    key={i}
                    className="text-base inline-flex w-full border-b pb-4 border-solid border-white mb-4 first:border-t first:pt-4"
                  >
                    <span
                      className="bg-white w-[14px] h-[14px] mr-7 block shrink-0 mt-2"
                      aria-hidden="true"
                    ></span>
                    {item.feature}
                  </li>
                ))}
              </ul>

              {/* Column 2 */}
              <ul className="w-full md:w-[calc(50%-1rem)] md:float-right list-none p-0 m-0">
                {col2.map((item, i) => (
                  <li
                    key={i}
                    className="text-base inline-flex w-full border-b pb-4 border-solid border-white mb-4 md:first:border-t md:first:pt-4"
                  >
                    <span
                      className="bg-white w-[14px] h-[14px] mr-7 block shrink-0 mt-2"
                      aria-hidden="true"
                    ></span>
                    {item.feature}
                  </li>
                ))}
              </ul>
              <div className="clear-both"></div>
            </div>
          );
        })()}
    </div>
  );
};